import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import Inputer from 'Utils/Helpers/Inputer';
import CButton from 'Utils/Helpers/CButton';
import { useSetState } from 'Utils/Helpers/Hooks';
import { useDispatch } from 'react-redux';
import { saveNewUser, users_data } from 'http/components/UserService';
import { SetUsersData } from 'Utils/Helpers/HandleApiData';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { enqueueSnackbar } from 'notistack';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewUser() {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false);
  const [ready, setReady] = useState(false);
  const [controls, setControls] = useSetState ({
    name: {
      id: "name",
      type: 'text',
      placeholder: 'نام و نام خانوادگی',
      value: '',
      icon: <icons.PersonSquare/>,
      force: true,
    },
    mobile: {
      id: "mobile",
      type: 'number',
      placeholder: 'شماره موبایل',
      value: '',
      icon: <icons.Telephone/>,
      force: true,
    },
    user_name: {
      id: "user_name",
      type: 'text',
      placeholder: 'نام کاربری',
      value: '',
      icon: <icons.Person/>,
      force: true,
    },
    pass_word: {
      id: "pass_word",
      type: 'password',
      placeholder: 'رمز عبور',
      value: '',
      icon: <icons.Key/>,
      force: true,
    },
  });

  const onEnter = () => {
    setControls({ name: { value: '' } });
    setControls({ mobile: { value: '' } });
    setControls({ user_name: { value: '' } });
    setControls({ pass_word: { value: '' } });
    setReady(true);
  }

  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }

  const setShowDialog = () => {
    setReady(false);
    setShow(true);
  }

  const handleClose= () => {
    setShow(false);
  }

  const onFinish = async () => {
    const {name, mobile, user_name, pass_word} = controls;
    dispatch(HandleLoading(true));
    if(name.value !== '' && mobile.value !== '' && user_name.value !== '' && pass_word.value !== '') {
      const response = await saveNewUser(name.value, mobile.value, user_name.value, pass_word.value);
      if(response.status) {
        const response2 = await users_data();
        if(response2.status) {
            await dispatch(SetUsersData(response2.data))
            enqueueSnackbar('کاربر جدید با موفقیت اضافه شد', {variant: 'success'});
            setShow(false);
        } else {
          dispatch(HandleLoading(false));
        }
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      enqueueSnackbar('اطلاعات کاربر به درستی وارد نشده است', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }

  return (
    <>
      <div className='home-btn-add'>
        <CButton
          text={'اضافه کردن کاربر جدید'}
          icon={<icons.PlusCircle/>}
          onClick={setShowDialog}
          className='home-btn h-lg with-shadow with-OP07'
        />
      </div>
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          TransitionProps={{onEnter: onEnter}}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          {
            ready &&
            <>
              <DialogTitle>
                {"اضافه کردن کاربر جدید"}
                <div className='close-btn' onClick={handleClose}>
                  <icons.X/>
                </div>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-appointment-edit">
                  <div className='flex-column-center-center w-100 px-2'>
                    {
                      Object.keys(controls).map((key, index) => {
                        return (
                          <Inputer
                            key={`inputer_${controls[key].id}`}
                            id={controls[key].id}
                            type={controls[key].type}
                            placeholder={controls[key].placeholder}
                            value={controls[key].value}
                            setValue={setControlsValue.bind(this)}
                            force={controls[key].force}
                            icon={controls[key].icon}
                            className={'mb-2'}
                          />
                        )
                      })
                    }
                  </div>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <CButton
                  text={'ذخیره کاربر جدید'}
                  icon={<icons.Save2/>}
                  onClick={onFinish}
                />
              </DialogActions>
            </>
          }
        </Dialog>
      }
    </>
  );
}
